/**
 *
 * The GDPR duck. No reducer, currently fire and forget.
 *
 * Action Types:
 * - GDPR_ACCEPTED
 * - GDPR_DECLINED
 * - LISTEN_FOR_CONSENT
 *
 * Action Creators:
 * - gdprAccepted()
 * - gdprDeclined()
 * - listenForConsent()
 */

/* Accepted and Declined need to be named similarly to other repos,
 * Breaking nomenclature to help out the data team.
 */

/** @type {ActionType} */
export const GDPR_ACCEPTED = 'GDPR_ACCEPTED';

/** @type {ActionType} */
export const GDPR_DECLINED = 'GDPR_DECLINED';

/** @type {ActionType} */
export const LISTEN_FOR_CONSENT = 'PB/GDPR/LISTEN_FOR_CONSENT';

/**
 * Creates an GDPR_ACCEPTED action
 *
 * @return {Action}
 * @property {string} type GDPR_ACCEPTED
 */
export function gdprAccepted() {
  return {
    type: GDPR_ACCEPTED,
  };
}

/**
 * Creates an GDPR_DECLINED action
 *
 * @return {Action}
 * @property {string} type GDPR_DECLINED
 */
export function gdprDeclined() {
  return {
    type: GDPR_DECLINED,
  };
}

/**
 * Creates an LISTEN_FOR_CONSENT action
 *
 * @return {Action}
 * @property {string} type LISTEN_FOR_CONSENT
 */
export function listenForConsent() {
  return {
    type: LISTEN_FOR_CONSENT,
  };
}
